import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLogedUser, setUser, updateSelectedDriver } from '../../redux/globals/globals.actions';
import { selectUser } from '../../redux/globals/globals.selectors';
import './Hangar.styles.scss';

const Hangar = () => {
	const user = useSelector(selectUser);
	const [selectedToken, setSelectedToken] = useState();
	const dispatch = useDispatch();

	useEffect(() => {
		for (let i = 0; i < user.tokens.ownedNfts.length; i++) {
			let tokenId = user.tokens.ownedNfts[i].id.tokenId;
			if (user.driver_contract === user.tokens.ownedNfts[i].contract.address && user.driver_token_id === tokenId) {
				setSelectedToken(user.tokens.ownedNfts[i]);
			}
		}
	}, []);

	useEffect(async () => {
		if (selectedToken && selectedToken.id.tokenId !== user.driver_token_id) {
			await dispatch(updateSelectedDriver(selectedToken));
			let res = await dispatch(getLogedUser());
			await dispatch(setUser(res.data));
		}
	}, [selectedToken]);

	return (
		<div className="hangarScreen">
			<div className="selectedDriver">
				<h2 className="mainTitle">Your ship</h2>
				<div className="description"></div>

				<div className={`driver`}>
					<img src={selectedToken?.media[0].raw} />

					<div className="details">
						<div className="title">{selectedToken?.title}</div>
						<div className="description">{selectedToken?.description}</div>
					</div>
				</div>
			</div>

			<div className="tokensList">
				<h2 className="mainTitle">Select your driver</h2>
				<div className="description">
					This is a list of all your available drivers. Your drivers are NFT's you own from the contracts we support. If you dont see your
					NFT, its becuase we didnt add it to our whitelist.{' '}
				</div>

				<div className="driversListOuter">
					<div className="driversListInner">
						<div className="driversList"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Hangar;
